import { createFileRoute } from '@tanstack/react-router';
import { redirectToVisualizationOfType } from 'src/lib/utils/roadmapping/redirectToVisualizationOfType';

export const Route = createFileRoute('/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/')({
  loader: async ({ params, context: { queryClient } }) => {
    await redirectToVisualizationOfType({
      org: params.org,
      roadmapId: Number(params.roadmapId),
      viewId: Number(params.viewId),
      queryClient,
    });
  },
});
